// extracted by mini-css-extract-plugin
export var attribution = "_d8-4";
export var authorName = "_d8-5";
export var quote = "_d8-3";
export var testimonial = "_d8-2";
export var trustedBy = "_d8-0";
export var trustedByLabel = "_d8-1";